import { render, staticRenderFns } from "./ActionListMng.vue?vue&type=template&id=b2b09ed8"
import script from "./ActionListMng.vue?vue&type=script&lang=js"
export * from "./ActionListMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b09ed8')) {
      api.createRecord('b2b09ed8', component.options)
    } else {
      api.reload('b2b09ed8', component.options)
    }
    module.hot.accept("./ActionListMng.vue?vue&type=template&id=b2b09ed8", function () {
      api.rerender('b2b09ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/ActionListMng.vue"
export default component.exports